"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeOutlineShorthand = exports.openOutlineShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
// outline
var openOutlineShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'outline',
        parts: [
            { prop: 'outline-style', dataType: css_data_types_1.outlineStyleDataType },
            { prop: 'outline-width', dataType: css_data_types_1.lineWidthDataType },
            { prop: 'outline-color', dataType: css_data_types_1.outlineColorDataType },
        ],
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openOutlineShorthand = openOutlineShorthand;
var closeOutlineShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " ", " ", ""], ["", " ", " ", ""])), 'outline-style', 'outline-width', 'outline-color'));
};
exports.closeOutlineShorthand = closeOutlineShorthand;
var templateObject_1;
//# sourceMappingURL=outline-shorthand.js.map